import { combineReducers } from 'redux';

import authReducer from './auth/reducer';
import cafesReducer from './cafes/reducer';
import cafesContractReducer from './contract/reducer';
import userReducer from './users/reducer';
import paymentsReducer from './payments/reducer';
import financialTransactionsReducer from './financialTransactions/reducer';
import settingsReducer from './settings/reducer';
import commentsReducer from './comments/reducer';
import changePasswordReducer from './changePassword/reducer';
import introducedCafesReducer from './introducedCafes/reducer';
import messagesReducer from './messages/reducer';
import invoicesReducer from './invoices/reducer';
import invoiceDeductionsReducer from './invoiceDeductions/reducer';
import invoiceAdditionsReducer from './invoiceAdditions/reducer';
import menuCategoriesReducer from './menuCategories/reducer';
import menuItemsReducer from './menuItems/reducer';
import reservationsReducer from './reservations/reducer';
import reserveTimesReducer from './reserveTimes/reducer';
import notificationsReducer from './notifications/reducer';
import dashboardReducer from './dashboard/reducer';
import discountCodesReducer from './discountCodes/reducer';
import workingHoursReducer from './workingHours/reducer';
import ticketsReducer from './tickets/reducer';
import cafeDiscountsReducer from './cafeDiscounts/reducer';
import rolesReducer from './roles/reducer';
import rseeDiscountsReducer from './rseeDiscounts/reducer';
import cafeEventsReducer from './cafeEvents/reducer';
import adsReducer from './ads/reducer';
import cafeTablesReducer from './cafeTables/reducer';
import checkoutReportsReducer from './checkouts/reports/reducer';
import checkoutsArchiveReducer from './checkouts/archives/reducer';
import salesReportReducer from './salesReport/reducer';
import completedReservesReportReducer from './reports/completedReservesReport/reducer';
import printerReducer from './printers/reducer';
import reservationTimetableReducer from './reservationTiming/reducer';
import takeawayReducer from './takeaway/reducer';
import rseePackagesReducer from './rseePackages/reducer';
import giftChairsReducer from './giftChairs/reducer';
import citiesReducer from './cities/reducer';
import regionsReducer from './regions/reducer';

const reducers = combineReducers({
  authReducer,
  cafesReducer,
  cafesContractReducer,
  userReducer,
  paymentsReducer,
  financialTransactionsReducer,
  settingsReducer,
  commentsReducer,
  changePasswordReducer,
  introducedCafesReducer,
  messagesReducer,
  invoicesReducer,
  invoiceDeductionsReducer,
  invoiceAdditionsReducer,
  menuCategoriesReducer,
  menuItemsReducer,
  reservationsReducer,
  reserveTimesReducer,
  notificationsReducer,
  dashboardReducer,
  discountCodesReducer,
  workingHoursReducer,
  ticketsReducer,
  cafeDiscountsReducer,
  rolesReducer,
  rseeDiscountsReducer,
  cafeEventsReducer,
  adsReducer,
  cafeTablesReducer,
  checkoutReportsReducer,
  checkoutsArchiveReducer,
  salesReportReducer,
  completedReservesReportReducer,
  printerReducer,
  reservationTimetableReducer,
  takeawayReducer,
  rseePackagesReducer,
  giftChairsReducer,
  citiesReducer,
  regionsReducer,
});

export default reducers;
